import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../../images/location_new/fold11/New-York.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              TekRevol’s Custom Mobile Application Development For Different
              Industries
            </h2>
            <p>
              TekRevol specializes in crafting custom mobile apps tailored for
              various industries.{" "}
            </p>
            <p>
              Our solutions adapt seamlessly to your business needs, providing
              efficient and user-friendly applications for lasting success.
            </p>
            <p>Here are the diverse industries that TekRevol caters to:</p>
            <ul>
              <li>Retail</li>
              <li>E-commerce</li>
              <li>Insurance</li>
              <li>FinTech</li>
              <li>Entertainment </li>
              <li>Health & Fitness</li>
              <li>Lifestyle</li>
              <li>Education</li>
              <li>Real Estate</li>
              <li>Logistics</li>
            </ul>
            <Link
              to="https://www.tekrevol.com/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
